<!--人文美育-视频库管理-->
<template>
    <div class="studio_nav_content" >
        <!--五馆合一-->
        <div class="page-mode" v-show="showMode==='page'">
            <div class="form-box"></div>
            <div class="museum-container">
                <div class="museum-item">
                    <div class="museum-img" title="精准·阅读拓展馆" @click="viewMuseum('ydtz')">
                        <img alt="精准·阅读拓展馆" class="img-100" src="../../assets/museum/ydtzg.jpg">
                    </div>
                </div>
                <div class="museum-item">
                    <div class="museum-img" title="精准·科技艺术馆" @click="viewMuseum('kjys')">
                        <img alt="精准·科技艺术馆" class="img-100" src="../../assets/museum/kjysg.jpg">
                    </div>
                </div>
                <div class="museum-item">
                    <div class="museum-img" title="精准·非遗文化馆" @click="viewMuseum('fywh')">
                        <img alt="精准·非遗文化馆" class="img-100" src="../../assets/museum/fywhg.jpg">
                    </div>
                </div>
                <div class="museum-item">
                    <div class="museum-img" title="精准·劳动实践馆" @click="viewMuseum('ldsj')">
                        <img alt="精准·劳动实践馆" class="img-100" src="../../assets/museum/ldsjg.jpg">
                    </div>
                </div>
                <div class="museum-item">
                    <div class="museum-img" title="精准·自然研学馆"  @click="viewMuseum('zryx')">
                        <img alt="精准·自然研学馆" class="img-100" src="../../assets/museum/zryxg.jpg">
                    </div>
                </div>
            </div>
        </div>
        <!--五馆阅读拓展-->
        <div class="museum-mode" v-show="showMode==='museum-ydtz'">
            <read-extension-museum @child-back-museum="childBackMuseum" />
        </div>

        <!--五馆科技艺术-->
        <div class="museum-mode" v-show="showMode==='museum-kjys'">
            <tech-art-museum @child-back-museum="childBackMuseum" />
        </div>

        <!--五馆非遗文化-->
        <div class="museum-mode" v-show="showMode==='museum-fywh'">
            <intangible-museum @child-back-museum="childBackMuseum" />
        </div>

        <!--五馆劳动实践-->
        <div class="museum-mode" v-show="showMode==='museum-ldsj'">
            <labor-practice-museum @child-back-museum="childBackMuseum" />
        </div>

        <!--五馆自然研学-->
        <div class="museum-mode" v-show="showMode==='museum-zryx'">
            <nature-study-museum @child-back-museum="childBackMuseum" />
        </div>
    </div>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import readExtensionMuseum from "@/components/newMuseum/readExtensionMuseum.vue";
import techArtMuseum from "@/components/newMuseum/techArtMuseum.vue";
import intangibleMuseum from "@/components/newMuseum/intangibleMuseum.vue";
import laborPracticeMuseum from "@/components/newMuseum/laborPracticeMuseum.vue";
import natureStudyMuseum from "@/components/newMuseum/natureStudyMuseum.vue";

export default {
    name: "newFiveMuseum",
    components: {readExtensionMuseum,techArtMuseum,intangibleMuseum,natureStudyMuseum,laborPracticeMuseum},
    data() {
        return {
            showMode:'page',
            museumMode:'museum-',
            serviceUrl,

        }
    },
    computed: {},
    watch: {},
    created() {
    },
    mounted(){},
    methods: {
        /*查看五馆*/
        viewMuseum(item){
            this.showMode = this.museumMode +item;
            this.$emit('change-mode',this.showMode, 30);
        },
        childBackMuseum(val){
            this.showMode = val;
        }
    }
}

</script>

<style scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.form-box{
    padding: 10px 20px 0 0;
    height: 40px;
}
.museum-container{
    width: 100%;
    height: calc(100vh - 160px);
    padding: 0 30px 0 30px;
    box-sizing: border-box;
    display: flex;
}
.museum-item{
    width: 20%;
    height: 100%;
    padding: 0 12px 0 12px;
    box-sizing: border-box;
    display: grid; place-items: center;
}
.museum-img{
    width: 100%;
    cursor: pointer;
    border: 1.5px solid #f1f1f1;
}
.museum-mode{
    width: 100%;
    height: auto;
}
</style>